export default __webpack_public_path__ + "static/media/arrow_right_sec.7195cea1.svg";